module.exports = __webpack_public_path__ + "static/keyboardNavigation-bcf8995099af76f6a8f9a8c09ab37b02.gif";